"use strict";

// const ac = require('ve-api-check');
var _require = require("lodash"),
    assign = _require.assign;

var _require2 = require('lodash'),
    identity = _require2.identity;

module.exports = function adjustRangeToRotation(rangeToBeAdjusted) {
  var rotateTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var rangeLength = arguments[2];

  // ac.throw([ac.range, ac.posInt, ac.posInt], arguments);
  var mod = rangeLength ? modulo : identity;

  var newRange = assign({}, rangeToBeAdjusted, {
    start: mod(rangeToBeAdjusted.start - (rotateTo || 0), rangeLength),
    end: mod(rangeToBeAdjusted.end - (rotateTo || 0), rangeLength)
  });

  return newRange;
};

function modulo(n, m) {
  return (n % m + m) % m;
}